import Link from "next/link";
import { useIntl } from "react-intl";
import { Section } from "@/components/common/section/Section";
import styles from "./UserInvalidate.module.scss";

type AccountErrorProps = {
  email: string;
};

export const UserInvalidate = ({ email }: AccountErrorProps) => {
  const intl = useIntl();

  return (
    <div className={styles.error}>
      <Section containerStyle={styles.errorContent}>
        <div className={styles.errorTitle}>
          {intl.formatMessage({ id: "userInvalidateTitle" })}
        </div>
        <div className={styles.errorBody}>
          <p>
            {email &&
              intl.formatMessage(
                { id: "userInvalidate" },
                {
                  b: () => <b>{email}</b>,
                  br: () => <br />,
                }
              )}
          </p>
          <div className={styles.action}>
            <button
              className={styles.reload}
              onClick={() => {
                window.location.reload();
              }}
            >
              {intl.formatMessage({ id: "reload" })}
            </button>

            <Link href="/">
              <a className={styles.goBackLink}>
                {intl.formatMessage({ id: "goBackHome" })}
              </a>
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
};
